<template>
    <div>
        <v-row class="px-2 pt-2">

            <!-- From Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="fromDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="fromDate"
                        @input="fromDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- To Date -->
            <v-col md="2" class="py-1">
                <v-menu
                    v-model="toDateModal"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                ><template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="toDate"
                        label="To Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="mt-0 pt-0"
                    ></v-text-field
                ></template>
                    <v-date-picker
                        v-model="toDate"
                        @input="toDateModal = false"
                        @click:date="handleDateFilters"
                    ></v-date-picker>
                </v-menu>
            </v-col>

            <!-- <v-col align="end" class="py-2">
                <v-btn
                    small
                    dark
                    color="primary"
                    class="mb-3"
                    @click="download"
                    ><v-icon>mdi-arrow-down-bold</v-icon>
                </v-btn>
            </v-col> -->
        </v-row>

        <v-row class="px-4">
            <v-col md="12" class="pa-2">
                <v-data-table
                    v-if="report"
                    :headers="headers"
                    :items="report"
                    :items-per-page="10"
                    class="elevation-0"
                    dense
                >
                <template v-slot:item.date>
                    {{ fromDate }} - {{ toDate }}
                </template>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

export default {
    data() {
        return {
            report: null,
            fromDateModal: null,
            toDateModal: null,
            fromDate: moment().startOf('month').format('YYYY-MM-DD'),
            toDate: moment().format('YYYY-MM-DD'),
            headers: [{ text: 'Date', value: 'date', sortable: false, align: "left" },
                      { text: 'Merchant Name', value: 'name', sortable: false, align: "left" },
                      { text: 'Seconds', value: 'tot_sec', sortable: false, align: "center" },
                      { text: 'Minutes', value: 'tot_min', sortable: false, align: "center" }]
        }
    },
    beforeMount() {
        this.getReport();
        console.log('test')
    },
    methods: {
        getReport() {
            axios({
            method: 'post',
            url: `get-call-logs`,
            data: { from: this.fromDate,
                    to: this.toDate },
            config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
            })
            .then(response => {
                this.report = response.data;
            })
            .catch(e => {
                this.errors.push(e)
            })
        },
        handleDateFilters() {
            if(this.toDate < this.fromDate) {
                this.fromDate = this.toDate;
            }
            this.getReport();
        },
        // download() {
        //     axios({
        //         method: 'post',
        //         url: 'download-chargeback-stats',  
        //         data: { from: this.fromDate,
        //                 to: this.toDate },            
        //         responseType: 'blob',
        //         config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }}
        //         })
        //         .then(response => {
        //             const url = window.URL.createObjectURL(new Blob([response.data]));
        //             const link = document.createElement('a');
        //             link.href = url;
        //             link.setAttribute('download', 'chargeback-stats.csv');
        //             document.body.appendChild(link);
        //             link.click();
        //         })
        //         .catch(e => {
        //             this.errors.push(e)
        //     })
        // }
    }
}
</script>

<style>

</style>